import React from 'react';
import { KitchenExcessReturnProvider } from 'contexts/kitchen/excess-returns.context';
import KitchenExcessReturnContent from './content';

const KitchenExcessReturnLayout = () => {
  return (
    <KitchenExcessReturnProvider>
      <KitchenExcessReturnContent />
    </KitchenExcessReturnProvider>
  );
};

export default KitchenExcessReturnLayout;
